import {
    CREATE_CUTTING_REPORT_PRINT_DATA,
    CREATE_CUTTING_REPORT_PRINT_FAILURE,
    CREATE_CUTTING_REPORT_PRINT_REQUEST,
    CREATE_CUTTING_REPORT_PRINT_SUCCESS,
    CREATE_USER_FORM_CUTTING_REPORTS,
    CUTTING_REPORT_PRINT_SUCCESS,
    FETCH_CUTTING_REPORT_ENTRY_HEADER_SUCCESS,
    FETCH_CUTTING_REPORT_HEADER_REQUEST,
    FETCH_CUTTING_REPORT_HEADER_SUCCESS,
    FETCH_CUTTING_REPORT_PRINT_FAILURE,
    FETCH_CUTTING_REPORT_PRINT_REQUEST,
    FETCH_CUTTING_REPORT_PRINT_SUCCESS,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_CUTTING_REPORT_PRINT,
    NAVIGATE_CUTTING_REPORTS_DEFAULT,
    NAVIGATE_CUTTING_REPORTS_DETAILS
} from "./cuttingReports.actionType";

export const CUTTING_REPORTS = 'cuttingReports';

let initialState = {
    loading: false,
    cuttingReportsData: [],
    cuttingReportsGSMData: [],
    cuttingReportsDetails: [],
    cuttingReportsDetailsAll: [],
    userform: {
        fldFKUnitId: -1,
        fldStartDate: new Date(),
        fldEndDate: new Date(),
        fldId: -1
    },
    errorMessage: '',
    isCuttingReports: 'cuttingReports',
    headerSearchCall: true,
    selectedRow: null,
    detailsId: '',
}

export let cuttingReportsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CUTTING_REPORT_HEADER_REQUEST:
        case FETCH_CUTTING_REPORT_PRINT_REQUEST:
        case CREATE_CUTTING_REPORT_PRINT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_CUTTING_REPORT_ENTRY_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingReportsGSMData: updatePayload,
                detailsId: updatePayload,
                userform: {
                    fldFKUnitId: state.userform.fldFKUnitId,
                    fldStartDate: state.userform.fldStartDate,
                    fldEndDate: state.userform.fldEndDate,
                    fldId: state.userform.fldId
                },
            }

        case FETCH_CUTTING_REPORT_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingReportsData: updatePayload,
                detailsId: updatePayload,
                userform: {
                    fldFKUnitId: state.userform.fldFKUnitId,
                    fldStartDate: state.userform.fldStartDate,
                    fldEndDate: state.userform.fldEndDate,
                    fldId: state.userform.fldId
                },
            }

        case FETCH_CUTTING_REPORT_PRINT_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingReportsDetails: updatePayload,
            }
        case CUTTING_REPORT_PRINT_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingReportsDetailsAll: updatePayload,
            }
        case FETCH_CUTTING_REPORT_PRINT_FAILURE:
            return {
                ...state,
                loading: false,
                cuttingReportsDetails: []
            }
        case CREATE_CUTTING_REPORT_PRINT_FAILURE:
            return {
                ...state,
                loading: false,
                cuttingReportsDetailsAll: [],
            }
        case CREATE_USER_FORM_CUTTING_REPORTS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };

        case CREATE_CUTTING_REPORT_PRINT_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKUnitId: state.userform.fldFKUnitId,
                    fldStartDate: state.userform.fldStartDate,
                    fldEndDate: state.userform.fldEndDate,
                },
            };

        case CREATE_CUTTING_REPORT_PRINT_DATA:
            return {
                ...state,
                loading: false,
                // cuttingReportsData: payload,
                cuttingReportsDetails: payload,
            }

        case NAVIGATE_CUTTING_REPORTS_DETAILS: {
            return {
                ...state,
                isCuttingReports: 'cuttingReportsData',
                // singleSalesOrderData: updatePayload.singleSalesOrder

            };
        }

        case NAVIGATE_CUTTING_REPORTS_DEFAULT: {
            return {
                ...state,
                // isCuttingReports: 'cuttingReports',
                userform: {
                    fldFKUnitId: state.userform?.fldFKUnitId,
                    fldStartDate: state.userform?.fldStartDate,
                    fldEndDate: state.userform?.fldEndDate,
                },
            }


        }
        case NAVIGATE_CUTTING_REPORT_PRINT: {
            return {
                ...state,
                loading: false,
                // userform: {
                //     ...updatePayload.userform, fldFKUnitId: state.userform?.fldFKUnitId,
                //     fldStartDate: state.userform?.fldStartDate,
                //     fldEndDate: state.userform?.fldEndDate
                // },
                selectedRow: updatePayload
            }

        }

        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }

        default:
            return state;
    }
}